import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';
import { DependentTableNames } from './store/types';

class ZakaznickaSkupinaProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		return `/${this.area}/${tableName}/Schema`;
	}

	tableUrl(tableName: DependentTableNames) {
		return `/${this.area}/${tableName}`;
	}
}

export const apiProvider = new ZakaznickaSkupinaProvider(DMS_MODULE, NAME);
